import React, { Component } from 'react';
import './index.css';

import * as _ from 'lodash'
import * as d3 from 'd3'
import State from '../State'

import {splitIntoVisibleAndInvisibleItems, commaFormat} from '../Helpers'

function StackedBar(props) {
  function handleMouseMove(e, d) {
    State.action('updateTooltip', {x: e.clientX, y: e.clientY, d: d})
  }

  function handleMouseOut() {
    State.action('updateTooltip', null)
  }

  let bars = props.values.map((d, i) => {
    if(d.w > 3) {
      return <a key={i} target="_blank" href={"http://search.electoralcommission.org.uk/Api/Spending/Invoices/" + d.invoiceId}><rect x={d.x} width={d.w} height={props.h} onMouseMove={(e) => handleMouseMove(e, d.d)} onMouseOut={handleMouseOut} /></a>
    }
    return <rect key={i} x={d.x} width={d.w} height={props.h} />
  })

  return (
    <g>{bars}</g>
  )
}

class SummaryColumn extends Component {

  render() {
    let max = d3.max(this.props.items, d => d.summary.expenditure.sum)
    let scale = d3.scaleLinear().domain([0, max]).range([0, State.columnWidths.Summary - 70])

    // console.log(State)
    // let timeScale = d3.scaleLinear().domain(State.timeExtent).range([0, 300])
    // TODO scale dates in preprocessing
    // let timeScale = d3.scaleLinear().domain([new Date(2016, 0, 1), new Date(2016, 6, 1)]).range([0, 300])


    let h = this.props.h
    let {aboveVisibleHeight, visibleItems, belowVisibleHeight} = splitIntoVisibleAndInvisibleItems({
      items: this.props.items,
      windowTop: window.scrollY,
      windowBottom: window.scrollY + window.innerHeight,
      h: h
    })

    let col = []

    // Spacer element
    col.push(<div className="offscreen" key="above" style={{height: aboveVisibleHeight}}></div>)

    _.each(visibleItems, (d, i) => {
      let value = d.summary.expenditure.sum

      let barStackValues = []
      let acc = 0
      d.values.forEach(d => {
        let item = {
          d: d,
          x: scale(acc)
        }
        acc += d['TotalExpenditure']
        item.w = scale(d['TotalExpenditure'])
        item.invoiceId = d['RedactedSupportingInvoiceId']
        barStackValues.push(item)
      })

      // let dates = d.values.map(d => timeScale(d['DateIncurred']))

      var xSum = scale(value)
      col.push(
        <svg key={d.pathId} width={State.columnWidths.Summary} height={h} >
          <text x={xSum + 6} y={18}>£{commaFormat(d.summary.expenditure.sum)}</text>
          <g transform="translate(0, 0)">
            <StackedBar values={barStackValues} h={h - 1} />
            <line x1={xSum} x2={xSum} y2={h - 1} />
          </g>
        </svg>
      )
    })

    // Spacer element
    col.push(<div className="offscreen" key="below" style={{height: belowVisibleHeight}}></div>)

    return <div className="column col-summary">{col}</div>
  }
}

export default SummaryColumn;



// WEBPACK FOOTER //
// ./src/SummaryColumn/index.js